import { render, staticRenderFns } from "./wishlistDetail.vue?vue&type=template&id=4cf7ca64"
import script from "./wishlistDetail.vue?vue&type=script&lang=js"
export * from "./wishlistDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports